<template>
  <div>
    <div v-if="typeOs === FALTA_NAP_LOTADA"
      class="group-input col-12 column q-mt-lg"
    >
      <label for="sinal_mdu"
        >O sinal do cliente é oriundo de um MDU?</label
      >
      <div class="flex row justify-around">
        <q-radio
          v-model="itemOsContract.sinal_mdu"
          keep-color
          size="lg"
          :val="1"
          label="Sim"
          color="red-6"
        />
        <q-radio
          v-model="itemOsContract.sinal_mdu"
          keep-color
          size="lg"
          :val="0"
          label="Não"
          color="red-6"
        />
      </div>
    </div>
    <div
    v-if="typeOs === FALTA_NAP_LOTADA"
      class="group-input col-12 column q-mt-lg"
    >
      <label for="falta_nap_ou_lotada"
        >A baixa está relacionada à Falta de NAP | NAP Lotada?</label
      >
      <div class="flex row justify-around">
        <q-radio
          v-model="itemOsContract.falta_nap_ou_lotada"
          keep-color
          size="lg"
          :val="1"
          label="Sim"
          color="red-6"
        />
        <q-radio
          v-model="itemOsContract.falta_nap_ou_lotada"
          keep-color
          size="lg"
          :val="0"
          label="Não"
          color="red-6"
        />
      </div>
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="Identificação da NAP"
        name="identificacao_nap"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        use-input
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        v-model="itemOsContract.identificacao_nap"
        name="identificacao_nap"
        bg-color="white"
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="Rua Transversal (A)"
        name="rua_transversal_a"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        use-input
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        name="rua_transversal_a"
        v-model="itemOsContract.rua_transversal_a"
        bg-color="white"
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="Rua Transversal (B)"
        name="rua_transversal_b"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        use-input
        name="rua_transversal_b"
        v-model="itemOsContract.rua_transversal_b"
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="Quantidade de saídas do NAP"
        name="qtd_saidas_nap"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        type="number"
        color="red-9"
        use-input
        name="qtd_saidas_nap"
        v-model="itemOsContract.qtd_saidas_nap"
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="Quantidade de imóveis conectados ao NAP"
        name="qtd_imoveis_conectados_nap"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        name="qtd_imoveis_conectados_nap"
        v-model="itemOsContract.qtd_imoveis_conectados_nap"
        type="number"
        use-input
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="Números dos imóveis conectados ao NAP"
        name="imoveis_conectados_ao_tap"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        v-model="itemOsContract.imoveis_conectados_ao_tap"
        name="imoveis_conectados_ao_tap"
        type="number"
        use-input
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="Identificação NAP anterior"
        name="nap_anterior"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        v-model="itemOsContract.nap_anterior"
        name="nap_anterior"
        use-input
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
    <div class="group-input col-12 row q-mt-sm">
      <RequiredLabel
        title="Identificação NAP posterior"
        name="nap_posterior"
      />
      <q-input
        class="col-12 q-mt-sm form-tabulacao"
        outlined
        dense
        color="red-9"
        v-model="itemOsContract.nap_posterior"
        name="nap_posterior"
        use-input
        fill-input
        input-debounce="0"
        placeholder="Digite aqui"
        bg-color="white"
        lazy-rules
        :rules="[(val) => !!val || 'Campo Obrigatório']"
      />
    </div>
  </div>
</template>

<script>
  import RequiredLabel from "@/components/SpecialCodes/RequiredLabel.vue";
import { FALTA_NAP_LOTADA } from "@/utils/constans/specialCodes";
import { inject, onBeforeMount } from "vue";

  export default {
    name: "MissingNapForm",
    components: {
      RequiredLabel,
    },
    props: {
      typeOs: Number,
      itemOsContract: Object,
    },

    setup(props, { emit }) {
      let requestData = {
        identificacao_nap: "",
        rua_transversal_a: "",
        rua_transversal_b: "",
        qtd_saidas_nap: "",
        qtd_imoveis_conectados_nap: "",
        imoveis_conectados_ao_tap: "",
        nap_anterior: "",
        nap_posterior: "",
      };

      let missingNapFormFields = {
        ...requestData,
        sinal_mdu: 0,
        falta_nap_ou_lotada: 0,
      }

      const addFieldsToRequestData = inject("addFieldsToRequestData");
      let newFields = props.typeOs === FALTA_NAP_LOTADA ? missingNapFormFields : requestData;

      onBeforeMount(() => {
        addFieldsToRequestData(newFields);
      });
      return {
        requestData,
        FALTA_NAP_LOTADA,
      };
    },
  };
</script>

<style scoped lang="scss">
  label {
    font-family: Roboto;
    font-style: normal;
  }

  .q-page-container {
    padding-bottom: 0px !important;
  }

  .label-checkbox-confirm {
    font-weight: 500 !important;
    font-size: 12px !important;
    line-height: 14px !important;
    letter-spacing: 0.01em !important;
    color: #999999 !important;
  }

  footer {
    background: #e5e5e5 !important;
    height: 12vh;

    .q-toolbar {
      height: 12vh;
    }

    .div-progress {
      height: 8vh;
    }

    .div-btn-next {
      height: 8vh;
    }
  }

  .section-service {
    width: 100%;

    .panel-services {
      background: transparent !important;
      overflow: hidden !important;

      .title-page {
        font-weight: bold;
        font-size: 18px;
        line-height: 19px;
        text-transform: uppercase;
        color: #e2262d;
      }

      .group-input {
        label {
          font-weight: bold;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.4);
        }
      }

      .label-requests-number {
        font-weight: 600;
        font-size: 15px;
        line-height: 20px;
        color: rgba(0, 0, 0, 0.5);
      }

      .label-requests-description {
        font-weight: 500;
        font-size: 12px;
        line-height: 20px;
        color: rgba(0, 0, 0, 0.8);
      }
    }
  }
</style>
